import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Brain } from 'lucide-react';
import ZihinRehberi from './ZihinRehberi';

const ZihinRehberiButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  return (
    <>
      <motion.div
        className="fixed bottom-[96px] md:bottom-24 right-6 z-[9998]"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 2, type: 'spring', stiffness: 200, damping: 20 }}
      >
        {/* Tooltip */}
        {isHovered && (
          <motion.div
            initial={{ opacity: 0, x: 8 }}
            animate={{ opacity: 1, x: 0 }}
            className="absolute right-full mr-4 top-1/2 -translate-y-1/2 whitespace-nowrap"
          >
            <div className="bg-[#0d0518]/95 backdrop-blur-2xl border border-purple-500/20 text-white/70 px-4 py-2.5 rounded-xl text-xs font-light tracking-wide shadow-2xl">
              Zihin Rehberi
            </div>
          </motion.div>
        )}

        <button
          onClick={() => setIsOpen(true)}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className="group relative flex items-center justify-center"
          data-testid="zihin-rehberi-trigger"
        >
          {/* Breathing outer glow */}
          <div className="absolute -inset-1 rounded-full bg-gradient-to-br from-purple-500/20 via-fuchsia-500/10 to-purple-600/20 blur-md animate-ctaPulse" />

          {/* Gradient border */}
          <div className="absolute -inset-[1px] rounded-full bg-gradient-to-br from-purple-500/40 via-fuchsia-400/25 to-purple-600/40 group-hover:from-purple-500/60 group-hover:via-fuchsia-400/40 group-hover:to-purple-600/60 transition-all duration-500" />

          {/* Button body */}
          <div className="relative w-11 h-11 rounded-full bg-[#0d0518]/90 backdrop-blur-2xl flex items-center justify-center transition-all duration-500 group-hover:bg-[#12061f]/90 text-purple-300/70 group-hover:text-purple-200">
            <Brain className="w-[18px] h-[18px]" />
          </div>
        </button>
      </motion.div>

      <ZihinRehberi isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default ZihinRehberiButton;
